import "./index.css";
import { MediaQueryContextProvider } from "./Context/MediaQueryContext";
import { PromptContextProvider } from "./Context/PromptContext";
import { ThemeContextProvider } from "./Context/ThemeContext";
import { UserContextProvider } from "./Context/UserContext";
import App from "./App";
import React from "react";
import ReactDOM from "react-dom/client";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <MediaQueryContextProvider>
      <PromptContextProvider>
        <ThemeContextProvider>
          <UserContextProvider>
            <App />
          </UserContextProvider>
        </ThemeContextProvider>
      </PromptContextProvider>
    </MediaQueryContextProvider>
  </React.StrictMode>
);
